import { CustomFieldEditDrawer } from '../translations-types';

const translations: CustomFieldEditDrawer = {
  createField: 'Aanmaken klantlabel',
  editField: 'Wijzigen klantlabel',
  addCustomField: 'Toevoegen klantlabel',
  areYouSureYouWantToDelete: 'Weet je zeker dat je klantlabel "{{name}}" wilt verwijderen?',
  deleteCustomField: 'Verwijder klantlabel',
};

export default translations;
